import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7e85b084"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "foot-bar-wrap"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "item-en"
};
const _hoisted_4 = {
  class: "item-cn"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-en"
}, "DATA LINK", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-cn"
}, "数据采集", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
import { useRoute, useRouter } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const navItems = [{
      path: "/",
      label: "首页",
      caption: "HOME"
    }, {
      path: "/device-status",
      label: "设备状态",
      caption: "STATUS"
    }, {
      path: "/waring-info",
      label: "报警信息",
      caption: "ALARM"
    }];
    const handleRoute = path => {
      router.push(path);
    };
    const openCollector = () => {
      window.open("http://collector.jyzk.com", "_blank");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, item => {
        return _createElementVNode("button", {
          key: item.path,
          class: _normalizeClass(["footbar-item", {
            active: _unref(route).path === item.path
          }]),
          onClick: $event => handleRoute(item.path)
        }, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.caption), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1)], 10, _hoisted_2);
      }), 64)), _createElementVNode("button", {
        class: "footbar-item footbar-item--external",
        onClick: openCollector
      }, _hoisted_7)]);
    };
  }
};